module.exports = __webpack_public_path__ + "assets/e8f5d7501034405eff5136071d362e17-DSC_0751.jpg";